import { render, staticRenderFns } from "./PurchaseCoin.vue?vue&type=template&id=05a6cb14&scoped=true&"
import script from "./PurchaseCoin.vue?vue&type=script&lang=js&"
export * from "./PurchaseCoin.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseCoin.vue?vue&type=style&index=0&id=05a6cb14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a6cb14",
  null
  
)

export default component.exports